import { render, staticRenderFns } from "./servers.vue?vue&type=template&id=79f495a6&"
import script from "./servers.ts?vue&type=script&lang=ts&"
export * from "./servers.ts?vue&type=script&lang=ts&"
import style0 from "./servers.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports